<template>
  <div>
    <p class="font-weight-bold mt-6 px-8" :class="consequence && 'mb-0'">
      Konsekvens
    </p>
    <p class="px-8 text-body-2 text--secondary">
      {{ consequence }}
    </p>
  </div>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
  name: 'TrafficMessageConsequenceText',

  computed: {
    consequence: get('trafficMessage/model@consequence')
  }
}
</script>
